import {Vehicle} from '@app/vehicle/shared/vehicle';

export class Stock {
  id: number;
  administrationId: number;
  vehicle: Vehicle;
  articleId: number;
  groupId: number;
  stockGroup: string;
  vatId: number;
  amount: number;
  purchasePrice: number;
  salesPrice: number;
  internetPrice: number;
  businessPrice: number;
  discriminator: string;
  visible: boolean;
}
